import React from "react";
import { classnames, Panel } from "@culturehq/components";

import styles from "./default-panel.module.scss";

type DefaultPanelProps = {
  className?: string;
};

const DefaultPanel: React.FC<DefaultPanelProps> = ({ className }) => (
  <Panel className={classnames(styles.panel, className)}>
    <Panel.Heading />
    <Panel.Body>
      <div className={styles.text} />
      <div className={styles.text} />
    </Panel.Body>
  </Panel>
);

export default DefaultPanel;
